<template>
  <!-- 筛选条件 -->
  <div class="screening_condition">
    <div class="px14 bold screening_header">筛选条件:</div>
    <!-- 地区 -->
    <div
      class="screening_property flex_jc_sb"
      v-for="(item, index) in areaListData"
      :key="index + 'area'"
    >
      <span>{{ item.name }}</span>
      <div class="img_clear" @click="handleClose(item)">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <!-- 一级分类 -->
    <div
      class="screening_property flex_jc_sb"
      v-for="(item, index) in constructionList"
      :key="index"
      v-show="item.show"
    >
      <span>{{ item.name }}</span>
      <div class="img_clear" @click="reset('constructionList')">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <!-- 二级分类 -->

    <div
      class="screening_property flex_jc_sb"
      v-for="(item, index) in constructionChildrenList"
      :key="index + 'children'"
      v-show="item.show"
    >
      <span>{{ item.name }}</span>
      <div class="img_clear" @click="reset('constructionChildrenList')">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <!-- 三级分类 -->
    <div
      class="screening_property flex_jc_sb"
      v-for="(item, index) in constructionthirdList"
      :key="index + 'children1'"
      v-show="item.show"
    >
      <span>{{ item.name }}</span>
      <div class="img_clear" @click="reset('constructionthirdList')">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <!-- 团队类型 -->
    <div
      class="screening_property flex_jc_sb"
      v-for="(item, index) in teamTypeList"
      :key="index + 'type'"
      v-show="item.show"
    >
      <span>{{ item.name }}</span>
      <div class="img_clear" @click="reset('teamTypeList')">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <!-- 团队状态 -->
    <div
      class="screening_property flex_jc_sb"
      v-for="(item, index) in teamStatusList"
      :key="index + 'status'"
      v-show="item.show"
    >
      <span>{{ item.name }}</span>
      <div class="img_clear" @click="reset('teamStatusList')">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <!-- 工种名称 -->
    <div
      class="screening_property flex_jc_sb"
      v-for="(item, index) in workTypeList"
      :key="index + 'work'"
      v-show="item.show"
    >
      <span>{{ item.name }}</span>
      <div class="img_clear" @click="reset('workTypeList')">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <!-- 设备名称 -->
    <div
      class="screening_property flex_jc_sb"
      v-for="(item, index) in EquList"
      :key="index + 'equ'"
      v-show="item.show"
    >
      <span>{{ item.name }}</span>
      <div class="img_clear" @click="reset('EquList')">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <!-- 团队规模 -->
    <div v-if="optionsTeamVal" class="screening_property flex_jc_sb">
      <span>{{ optionsTeamVal }}</span>
      <div class="img_clear" @click="resetSelect('optionsTeamVal')">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <div
      v-if="
        isShow ||
          areaShow ||
          typeShow ||
          statusShow ||
          sizeShow ||
          workTypeShow ||
          EquListShow
      "
      class="closeAll"
      @click="closeAll()"
    >
      清空筛选
    </div>
  </div>
</template>

<script>
export default {
  name: "Screen",
  components: {},
  data() {
    return {
      isShow: false,
      areaShow: false,
      typeShow: false,
      statusShow: false,
      workTypeShow: false,
      EquListShow: false,
      sizeShow: false,
      areaListData: []
    }
  },
  props: {
    screenList: {
      type: Object,
      required: true
    },
    constructionList: {
      type: Array
    },
    constructionChildrenList: {
      type: Array
    },
    constructionthirdList: {
      type: Array
    },
    constructionTeamSizeList: {
      type: Array
    },
    teamTypeList: {
      type: Array
    },
    teamStatusList: {
      type: Array
    },
    workTypeList: {
      type: Array
    },
    EquList: {
      type: Array
    },
    // 团队规模
    optionsTeamVal: {
      type: String
    }
  },
  computed: {},
  methods: {
    handleClose(data) {
      this.$emit("clearOne", data)
    },
    resetSelect() {
      this.$emit("change", "constructionTeamSizeList", "", "")
    },
    reset(name) {
      this.$parent.$refs.SelectionSort.reset(name)
    },

    closeAll() {
      this.$parent.$refs.SelectionSort.reset("constructionList")
      this.$parent.$refs.SelectionSort.reset("constructionTeamSizeList")
      this.$parent.$refs.SelectionSort.reset("workTypeList")
      this.$emit("clearAllarea")
      this.$emit("close", "all")
      this.resetSelect()
    }
  },
  watch: {
    constructionList(newValue, o) {
      let arr1 = newValue.some(item => item.show === true)
      this.isShow = arr1
    },
    constructionChildrenList() {
      //
    },
    constructionthirdList() {},
    "screenList.areaList"(newValue, o) {
      if (newValue.length>0) {
        this.areaListData = newValue
        this.areaShow = true
      }
      else {
        this.areaListData = newValue
        this.areaShow = false
      }
    },
    EquList(newValue, o) {
      let arr1 = newValue.some(item => item.show === true)
      this.EquListShow = arr1
    },
    workTypeList(newValue, o) {
      let arr1 = newValue.some(item => item.show === true)
      this.workTypeShow = arr1
    },
    teamStatusList(newValue, o) {
      let arr1 = newValue.some(item => item.show === true)
      this.statusShow = arr1
    },
    teamTypeList(newValue, o) {
      let arr1 = newValue.some(item => item.show === true)
      this.typeShow = arr1
    },
    optionsTeamVal(newValue, o) {
      if (newValue) {
        this.sizeShow = true
      } else {
        this.sizeShow = false
      }
    },
    optionsTypeVal(newValue, o) {
      if (newValue) {
        this.optionTypeShow = true
      } else {
        this.optionTypeShow = false
      }
    },
    optionsStatusVal(newValue, o) {
      if (newValue) {
        this.optionStatusShow = true
      } else {
        this.optionStatusShow = false
      }
    }
  }
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.screening_header {
  width: 130px;
  text-align: center;
  font-size: 14px;
  height: 33px;
  line-height: 33px;
}
.screening_condition {
  background-color: #fff;
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
  border-top: 1px solid #e4e7ed;
  padding: 5px 0;
  display: flex;
  margin: 0 auto;
  width: 1198px;
  height: 32px;
  align-items: center;
  // margin-bottom: 10px;
}
.screening_inner {
  padding: 5px;
  font-size: 14px;
  display: inline-block;
  background: #fff;
  color: #747474;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  margin-right: 5px;
}
.screening_property {
  height: 31px;
  line-height: 31px;
  padding: 0 13px;
  font-size: 14px;
  display: inline-block;
  background: #fff;
  color: #969696;
  background-color: #f5f7fa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin-right: 10px;
  .img_clear {
    width: 10px;
    height: 10px;
    display: inline-block;
    margin: 0 0 0 5px;
    cursor: pointer;
  }
}
.closeAll {
  font-size: 14px;
  color: #666666;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  cursor: pointer;
}
.bold {
  font-weight: 400;
  color: #666666;
}
</style>
